import React, { useState } from "react"
import { useSelector } from "react-redux"

import { ACTIVE, YES } from "const"
import {
    StoreType,
    ProjectActiveModules,
    moduleIds,
} from "client/store"
import {
    PageContent,
    Collapse,
    PermissionTable,
} from "client/components"

import Columns from "./columns"

const Permissions = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const permissions = useSelector((state: StoreType) => state.projectPermissions.projectPermissions)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const [showProject, setShowProject] = useState(true)
    const [showCc, setShowCc] = useState(false)
    const [showLifecycle, setShowLifecycle] = useState(false)
    const [showSil, setShowSil] = useState(false)
    const [showRrs, setShowRrs] = useState(false)
    const [showStudy, setShowStudy] = useState(false)

    const {
        ccModuleAccess,
        lifecycleModuleAccess,
        silModuleAccess,
        rrsRiskSpaceModuleAccess,
        studyModuleAccess,
    } = packageSettings

    const {
        cc,
        lifecycle,
        sil,
        riskSpace,
        study,
    } = moduleIds

    const columns = Columns()
    const projectActiveModules: ProjectActiveModules = project.modules ? JSON.parse(project.modules) : {}

    return (
        <PageContent>
            <Collapse
                show={showProject}
                title={lang.project}
                onCollapse={() => setShowProject(!showProject)}
            >
                <PermissionTable
                    columns={columns}
                    section="project"
                    dataList={permissions.project}
                />
            </Collapse>
            {
                ccModuleAccess === YES
                && moduleList[cc].status === ACTIVE
                && projectActiveModules[cc]
                && (
                    <Collapse
                        show={showCc}
                        title={moduleList[cc].name}
                        onCollapse={() => setShowCc(!showCc)}
                    >
                        <PermissionTable
                            columns={columns}
                            section="complianceCase"
                            dataList={permissions.complianceCase}
                        />
                    </Collapse>
                )
            }
            {
                lifecycleModuleAccess === YES
                && moduleList[lifecycle].status === ACTIVE
                && projectActiveModules[lifecycle]
                && (
                    <Collapse
                        show={showLifecycle}
                        title={moduleList[lifecycle].name}
                        onCollapse={() => setShowLifecycle(!showLifecycle)}
                    >
                        <PermissionTable
                            columns={columns}
                            section="lifecycle"
                            dataList={permissions.lifecycle}
                        />
                    </Collapse>
                )
            }
            {
                silModuleAccess === YES
                && moduleList[sil].status === ACTIVE
                && projectActiveModules[sil]
                && (
                    <Collapse
                        show={showSil}
                        title={moduleList[sil].name}
                        onCollapse={() => setShowSil(!showSil)}
                    >
                        <PermissionTable
                            columns={columns}
                            section="sil"
                            dataList={permissions.sil}
                        />
                    </Collapse>
                )
            }
            {
                rrsRiskSpaceModuleAccess === YES
                && moduleList[riskSpace].status === ACTIVE
                && projectActiveModules[riskSpace]
                && (
                    <Collapse
                        show={showRrs}
                        title={moduleList[riskSpace].name}
                        onCollapse={() => setShowRrs(!showRrs)}
                    >
                        <PermissionTable
                            columns={columns}
                            section="rrs"
                            dataList={permissions.rrs}
                        />
                    </Collapse>
                )
            }
            {
                studyModuleAccess === YES
                && moduleList[study].status === ACTIVE
                && projectActiveModules[study]
                && (
                    <Collapse
                        show={showStudy}
                        title={moduleList[study].name}
                        onCollapse={() => setShowStudy(!showStudy)}
                    >
                        <PermissionTable
                            columns={columns}
                            section="study"
                            dataList={permissions.study}
                        />
                    </Collapse>
                )
            }
        </PageContent>
    )
}
export default Permissions
